import React from "react";
import { Row, Col } from "reactstrap";
import { Text, Button, Headline, ImageCard as Card } from "@jobmatchme/ui";
import styles from "./style.module.scss";
import johsMartensImage from "./johs-martens-news.png";

const SuccessStory = () => (
  <Card>
    <Row>
      <Col xs={12} md={3} className={styles.imageWrapper}>
        <img src={johsMartensImage} alt="Susanne Martens-Ulrich" />
        <div className={styles.imageSubline}>
          <b>Susanne Martens-Ulrich</b>
          <br />
          Geschäftsführerin
        </div>
      </Col>
      <Col xs={12} md={9} className={styles.successStory}>
        <Headline size={4}>
          Für 18 Standorte LKW-Fahrer zu finden ist eine riesige Herausforderung
        </Headline>
        <Text>
          Die Rekrutierung über TruckJobs ist einfach, auf uns angepasst und
          komfortabel.
        </Text>
        <a href="/de/arbeitgeber/#successStory2">
          <Button color="light" className={styles.readMore}>
            Mehr erfahren
          </Button>
        </a>
      </Col>
    </Row>
  </Card>
);

export default SuccessStory;
